module.exports = {
  PREPARED: 'prepared',
  REPAIRED: 'repaired',
  TRANSPORTED: 'transported',
  SHIPPED: 'shipped',
  RETURNED: 'returned',
  CANCELED: 'canceled',
};
